import types from './types';

const mutations = {
  [types.CLOSE_SNACKBAR](state) {
    state.snackbarConfig = {};
    state.showSnackbar = false;
  },
  [types.SHOW_SNACKBAR](state, payload) {
    state.snackbarConfig = {
      ...state.snackbarDefaults,
      ...payload,
    };
    state.showSnackbar = true;
    setTimeout(() => {
      state.snackbarConfig = {};
      state.showSnackbar = false;
    }, state.snackbarConfig.timeout || 4000);
  },
  [types.UPDATE_AUTH_USER](state, payload) {
    state.user = payload;
  },
  [types.UPDATE_LOCAL_USER](state, payload) {
    state.user = {
      ...state.user,
      ...payload,
    };
  },
};

export default mutations;
